import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IEmptyResult } from '~src/httpClient/serverApi/types/IResponse';

export type ResumeLinkedTasksParams = {
  readonly ids: string[];
}

export class ResumeLinkedTasksRequest extends Request<ResumeLinkedTasksParams, IEmptyResult> {
  constructor(params: ResumeLinkedTasksParams) {
    super('resumeLinkedTasks', params);
  }
}
